import axios from "axios";
import { useQuery } from "react-query";
import { API_ENDPOINT } from "../../constants/constants";
import { getHeader } from "../../utils/util";

const useApiEp = (path, enabled = true) => {
  const URL_EP = `${API_ENDPOINT}${path}`;
  return useQuery({
    queryKey: [URL_EP],
    queryFn: async () => {
      const response = await axios.get(URL_EP, getHeader());
      return response.data;
    },
    retry: 1,
    refetchOnWindowFocus: false,
    enabled: enabled,
  });
};

export default useApiEp;
